import React, { useState, useEffect } from 'react'
import { styled } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faChevronRight, faC, faLightbulb, faHouseSignal, faArrowUpFromWaterPump,  } from '@fortawesome/free-solid-svg-icons'
import {faJava, faPython, faGithub } from '@fortawesome/free-brands-svg-icons'
import './Menu.css'
import { Link } from 'react-router-dom'

const Container = styled.div`
    background: #292b48;
    height: calc(100vh - 70px);
    color: #fff;
    overflow-x: hidden;
    transition: all 0.5s;
`;

const Menu = ({navCollapse, handleToggle}) => {
    
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      function handleResize() {
        setWidth(window.innerWidth);
      }
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [width]);

    function handleMobileClick() {
        if(width < 769){
            handleToggle();
        }
    }

    return (
        <Container className={`sidebar ${navCollapse ? "smallnav" : ""}`}>
            <div className={`container`}>
                <p className='pt-3 ms-3 sec-head'>PROGRAMS</p>
                <ul>
                    <Link to="/cprograms" onClick={handleMobileClick}>
                        <li>
                            <span className='prog-icon'><FontAwesomeIcon icon={faC} /></span> C Programs <span className='arrow-icon'><FontAwesomeIcon icon={faChevronRight} /></span>
                        </li>
                    </Link>
                    <Link to="/java" onClick={handleMobileClick}>
                        <li>
                            <span className='prog-icon'><FontAwesomeIcon icon={faJava} /></span> JAVA Programs <span className='arrow-icon'><FontAwesomeIcon icon={faChevronRight} /></span>
                        </li>
                    </Link>
                    <Link to="/python" onClick={handleMobileClick}> 
                        <li>
                            <span className='prog-icon'><FontAwesomeIcon icon={faPython} /></span> Python Programs <span className='arrow-icon'><FontAwesomeIcon icon={faChevronRight} /></span>
                        </li>
                    </Link>
                </ul>
                <p className='pt-3 ms-3 sec-head'>PROJECTS</p>
                <ul>
                    <li onClick={handleMobileClick}>
                    <span className='prog-icon'><FontAwesomeIcon icon={faLightbulb} /></span> <a href="https://www.instructables.com/8-Relay-Control-With-NodeMCU-and-IR-Receiver-Using/" target='_blank' rel="noreferrer">8 Channel Relay</a> <span className='arrow-icon'><FontAwesomeIcon icon={faChevronRight} /></span>
                    </li>
                    <li onClick={handleMobileClick}>
                    <span className='prog-icon'><FontAwesomeIcon icon={faHouseSignal} /></span> <a href="https://www.instructables.com/Home-Automation-With-Google-Assistant-Node-Mcu-And/" target='_blank' rel="noreferrer">8 Relay Automation</a> <span className='arrow-icon'><FontAwesomeIcon icon={faChevronRight} /></span>
                    </li>
                    <li onClick={handleMobileClick}>
                    <span className='prog-icon'><FontAwesomeIcon icon={faArrowUpFromWaterPump} /></span> <a href="https://www.instructables.com/Automate-Submersible-Pump-With-Start-Cap-Wifi-ESP8/" target='_blank' rel="noreferrer">Pump Automation</a> <span className='arrow-icon'><FontAwesomeIcon icon={faChevronRight} /></span>
                    </li>
                    <li onClick={handleMobileClick}>
                    <span className='prog-icon'><FontAwesomeIcon icon={faGithub} /></span> <a href="https://github.com/amitsamanta996/ha-miraie-ac" target='_blank' rel="noreferrer">AC Home Assistant</a> <span className='arrow-icon'><FontAwesomeIcon icon={faChevronRight} /></span>
                    </li>
                </ul>
            </div>
        </Container>  
    )
}

export default Menu